import React, { useCallback } from 'react';
import { View } from 'react-native';
import { AUSTRALIAN_STATES, COUNTRY, ROLE_PERMISSIONS } from '../../../common/constants';
import { useAppContext } from '../../../common/utils/context';
import { useUserContext } from '../../../common/utils';

import { Picker, TypographyHeading } from '../../components';
import { TextInputEditInPlace } from '../../components/input';

const AddressForm = ({ data, onChange }) => {
	const address = data || {};
	const { hasPermission } = useUserContext();
	const canEditLocation = hasPermission(ROLE_PERMISSIONS.ADD_EDIT_LOCATIONS);
	const onChangeRegion = useCallback(value => onChange({ region: value }), [onChange]);
	const { region } = useAppContext();

	return (
		<View>
			<TypographyHeading
				fieldLabel={true}
				label="Street"
			/>
			<TextInputEditInPlace
				field="street"
				value={address.street}
				placeholder="No street"
				disabled={!canEditLocation}
				onConfirm={onChange}
			/>
			<TypographyHeading
				fieldLabel={true}
				label="City"
			/>
			<TextInputEditInPlace
				value={address.city}
				placeholder="No city"
				field="city"
				disabled={!canEditLocation}
				onConfirm={onChange}
			/>
			<TypographyHeading
				fieldLabel={true}
				label="State"
			/>
			{
				region !== COUNTRY.AUSTRALIA &&
				(
					<TextInputEditInPlace
						value={address.region}
						placeholder="No state"
						field="region"
						disabled={!canEditLocation}
						onConfirm={onChange}
					/>
				)
			}
			{
				region === COUNTRY.AUSTRALIA &&
				(
					<Picker
						selectedValue={address.region}
						onValueChange={onChangeRegion}
						options={Object.keys(AUSTRALIAN_STATES).map(type => ({
							label: AUSTRALIAN_STATES[type],
							value: type,
						}))}
						disabled={!canEditLocation}
					/>
				)
			}
			<TypographyHeading
				fieldLabel={true}
				label="Postcode"
			/>
			<TextInputEditInPlace
				value={address.postcode}
				placeholder="No postcode"
				field="postcode"
				disabled={!canEditLocation}
				onConfirm={onChange}
			/>
		</View>
	);
};

export default AddressForm;
